// extracted by mini-css-extract-plugin
export default {"root":"NoticeLayout_root__6zPWQ","body":"NoticeLayout_body__5ae8I"};